export default function detectFiltersSticky() {
  function init() {
    const filters = document.querySelectorAll(".object-filters");
    const tableFilters = document.querySelector(".table-filters-details");
    const sentinalEl = document.querySelector(".sticky-detect");

    const config = {
      rootMargin: "-140px 0px 0px 0px",
    };

    const handler = (entries) => {
      if (!entries[0].isIntersecting) {
        const largeScreen = window.matchMedia("(min-width: 1150px)");
        largeScreen.addListener(handleScreenChange);

        function handleScreenChange(e) {
          if (e.matches) {
            tableFilters.classList.add("hidden");
          }
        }
        // Run it initially
        handleScreenChange(largeScreen);

        filters.forEach((filter) => {
          filter.classList.add("is-sticky");
        });
      } else {
        const largeScreen = window.matchMedia("(min-width: 1150px)");
        largeScreen.addListener(handleScreenChange);

        function handleScreenChange(e) {
          if (e.matches) {
            tableFilters.classList.remove("hidden");
          }
        }
        // Run it initially
        handleScreenChange(largeScreen);

        filters.forEach((filter) => {
          filter.classList.remove("is-sticky");
        });
      }
    };

    const observer = new window.IntersectionObserver(handler, config);
    observer.observe(sentinalEl);

    const mobileScreen = window.matchMedia("(max-width: 1149px)");
    mobileScreen.addListener(handleScreenChange);

    function handleScreenChange(e) {
      if (e.matches) {
        tableFilters.classList.add("hidden");
      }
    }
    // Run it initially
    handleScreenChange(mobileScreen);
  }

  const isPresent = document.getElementsByClassName("object-filters");
  if (isPresent.length > 0) {
    init();
  }
}
